/**
 * Shared print-window helper used by every "Print ___" feature (QR labels,
 * hive/site/season reports). Opens a blank tab, writes a self-contained
 * print-friendly HTML document into it, and triggers window.print(). Kept
 * framework-free (no mounting a React tree in the new window) since the
 * popup is a separate browsing context.
 */
export function openPrintWindow(title, bodyHtml, { watermark } = {}) {
  const win = window.open("", "_blank", "width=850,height=1100");
  if (!win) return; // popup blocked -- caller's UI should already indicate this is a print action

  const watermarkHtml =
    watermark && watermark !== "None"
      ? `<div class="watermark">${watermark.toUpperCase()}</div>`
      : "";

  win.document.write(`<!doctype html>
<html>
<head>
<title>${title}</title>
<style>
  body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif; padding: 32px; color: #1a1a1a; position: relative; }
  h1 { margin: 0 0 4px; font-size: 1.5rem; }
  h2 { margin: 24px 0 8px; font-size: 1.1rem; border-bottom: 2px solid #eee; padding-bottom: 4px; }
  .meta { color: #666; font-size: 0.85rem; margin-bottom: 16px; }
  table { width: 100%; border-collapse: collapse; margin: 8px 0 20px; }
  th, td { text-align: left; padding: 6px 10px; border-bottom: 1px solid #e2e2e2; font-size: 0.85rem; }
  th { background: #f7f7f5; font-weight: 600; }
  .qr-block { display: flex; align-items: center; gap: 16px; margin: 16px 0; }
  .summary-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 12px; margin: 16px 0; }
  .summary-card { border: 1px solid #e2e2e2; border-radius: 8px; padding: 10px 14px; }
  .summary-card .value { font-size: 1.4rem; font-weight: 700; }
  .summary-card .label { font-size: 0.75rem; color: #666; }
  .watermark {
    position: fixed; top: 42%; left: 8%; transform: rotate(-28deg);
    font-size: 6rem; font-weight: 800; letter-spacing: 0.15em;
    color: rgba(200, 30, 30, 0.16); z-index: 1000; pointer-events: none;
    white-space: nowrap;
  }
  .no-print { margin-top: 24px; }
  @media print { .no-print { display: none; } }
</style>
</head>
<body>
${watermarkHtml}
${bodyHtml}
<div class="no-print">
  <button onclick="window.print()">Print</button>
</div>
</body>
</html>`);
  win.document.close();
  win.focus();
  setTimeout(() => win.print(), 350);
}
